import { Locale } from '@yi/core';

export const i18nPhrasesTimer = {
  days: (locale: Locale) => {
    const en = `DAYS`;
    const phrases: { [key: string]: undefined | string } = {
      en,
      es: `DÍAS`,
    };
    return phrases[locale] || en;
  },
  hrs: (locale: Locale) => {
    const en = `HRS`;
    const phrases: { [key: string]: undefined | string } = {
      en,
      es: `HRS`,
    };
    return phrases[locale] || en;
  },
  min: (locale: Locale) => {
    const en = `MIN`;
    const phrases: { [key: string]: undefined | string } = {
      en,
      es: `MIN`,
    };
    return phrases[locale] || en;
  },
  sec: (locale: Locale) => {
    const en = `SEC`;
    const phrases: { [key: string]: undefined | string } = {
      en,
      es: `SEG`,
    };
    return phrases[locale] || en;
  },
};
